import { xmlElementToDataElement, elementWithoutMetadataToJS } from "./XML2ViewModelUtils"


function XMLStr2Viewmodel(val) {
  if (typeof val === "string") {
    val = val.replaceAll('\\n', '\n');
    val = val.replaceAll('\\\\', '\\');
  }
  return val;
}

function replaceElementValues(metadata, dataElement, node) {
  let attributeNames = node.getAttributeNames();
  let updateAttributes = {};
  attributeNames.forEach(attribName => { updateAttributes[attribName] = XMLStr2Viewmodel(node.getAttribute(attribName) ); });
  dataElement.update(updateAttributes);
}

/**
 *
 * @param {*} node
 * @param {import("../xmlrdb-data/DataElement").default} dataElement
 * @param {import("../xmlrdb-metadata/XMLRDBNavigation").default} metadata
 */
function replaceSubElements(node, dataElement, metadata) {
  let nodeMetaGroups = {};
  // @ts-ignore
  dataElement.subElements.keys.forEach( key => nodeMetaGroups[key] = []);
  node.childNodes.forEach(childNode => {
    if (childNode instanceof Element && !childNode.tagName.startsWith("meta:")) { // das ist das Element aus dem Browser
      
      let metaId = childNode.getAttribute("meta:id")
      if (!Object.prototype.hasOwnProperty.call(nodeMetaGroups, metaId)) {
        elementWithoutMetadataToJS(childNode, dataElement);
      }
      else {
        nodeMetaGroups[metaId].push(childNode);
      }
    }
  });



  for (let metaId in nodeMetaGroups) {
    if (!Object.prototype.hasOwnProperty.call(dataElement.subElements, metaId)) {
      console.debug(dataElement);
      throw `${metaId} nicht im dataElement vorhanden`;
    }
    /** @type {import("../xmlrdb-data/ElementArray").default } */
    let elementArray = dataElement.subElements[metaId];
    let elementMeta = dataElement.subElements[metaId].metadata;
    let newDataLength = nodeMetaGroups[metaId].length;
    elementArray.dispatch("beforeupdate");

    while ( elementArray.dataElements.length > newDataLength) {
      elementArray.removeElement(elementArray.dataElements[elementArray.dataElements.length-1]);
    }

    let elemArrayLength = elementArray.dataElements.length;
    let i = 0;
    for (; i < elemArrayLength; i++){
      replaceSubElements(nodeMetaGroups[metaId][i], elementArray.dataElements[i], metadata);
      replaceElementValues(elementMeta, elementArray.dataElements[i], nodeMetaGroups[metaId][i]);
    }

    while (i < newDataLength) {
      dataElement.addSubElement(elementMeta, xmlElementToDataElement(nodeMetaGroups[metaId][i], metadata), true);
      i++;
    }
    elementArray.update();
  }
}
/**
 *
 * @param {XMLDocument} xml
 * @param {import("./RootElement").default} viewModel
 */
export function updateViewModel(xml, viewModel) {
  let node = xml.firstElementChild;
  replaceSubElements(node, viewModel, viewModel.rootMetadata);
  viewModel.dispatch("updated");
}